import * as React from "react";
import styled from "styled-components";
import DrawerCategory from "./drawer-category";
import Link from "../link/link";

const UnstyledLink = styled(Link)`
  all: unset;
  cursor: pointer;
`;

const Root = styled.div`
  height: 100%;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.cloud};
  padding: 10px;
`;

const Content = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FreeTrialLink = styled(UnstyledLink)`
  display: block;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.ice};
  color: ${({ theme }) => theme.colors.awesome};
`;

function DrawerItem(props) {
  const { item, onClose } = props;
  return (
    <>
      <Root data-component-name="drawer-item">
        <Content>
          {item.dropdownItems?.map((category) => (
            <DrawerCategory
              key={category.text}
              item={category}
              onClose={onClose}
            />
          ))}
        </Content>
      </Root>
      <FreeTrialLink
        url="https://www.vorne.com/products/free-trial/"
        onClick={onClose}
      >
        Try XL Free for 90 Days
      </FreeTrialLink>
    </>
  );
}

export default DrawerItem;
